module.exports = __webpack_public_path__ + "static/media/codeClock.c99fe953.jpg";